import * as TriggersConstants from './TriggersConstants';
import {
  STATUS_FAILURE,
  STATUS_PENDING,
  STATUS_SUCCESS,
} from 'Common/constants/commonConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
  offlineTriggerConfigs: [],
  offlineTriggerConfigsLoading: null,
  offlineTriggerConfigsError: null,
  offlineTriggerSaving: false,
  offlineUnitIdNameMap: {},
  offlineSeverityIdNameMap: {},
  isTriggerSavedSuccessPopup: false,
  saveSuccessTriggerMessage: "",
  isTriggerSavedErrorPopup: false,
  saveErrorTriggerMessage: "",
};

export default function OfflineTriggerReducer(state = initialState, action) {
  switch (action.type) {

    case TriggersConstants.FETCH_OFFLINE_TRIGGER_CONFIGS_REQUEST:
      return assign({}, state, {
        offlineTriggerConfigsLoading: STATUS_PENDING,
        offlineTriggerConfigsError: null
      });

    case TriggersConstants.FETCH_OFFLINE_TRIGGER_CONFIGS_SUCCESS:
      return assign({}, state, {
        offlineTriggerConfigs: action.payload.configs,
        offlineUnitIdNameMap: action.payload.unitIdNameMap || {},
        offlineSeverityIdNameMap: action.payload.severityIdNameMap || {},
        offlineTriggerConfigsLoading: STATUS_SUCCESS,
        offlineTriggerConfigsError: null
      });

    case TriggersConstants.FETCH_OFFLINE_TRIGGER_CONFIGS_FAILURE:
      return assign({}, state, {
        offlineTriggerConfigsLoading: STATUS_FAILURE,
        offlineTriggerConfigsError: action.error
      });

    case TriggersConstants.UPDATE_OFFLINE_TRIGGER_CONFIG_LOCAL: {
      const updatedLocal = state.offlineTriggerConfigs.map(cfg =>
        cfg.triggerType === action.triggerType ? { ...cfg, [action.field]: action.value } : cfg
      );
      return assign({}, state, {
        offlineTriggerConfigs: updatedLocal
      });
    }

    case TriggersConstants.UPDATE_OFFLINE_TRIGGER_CONFIG_REQUEST:
      return assign({}, state, {
        offlineTriggerSaving: true
      });

    case TriggersConstants.UPDATE_OFFLINE_TRIGGER_CONFIG_SUCCESS: {
      const updatedConfigs = state.offlineTriggerConfigs.map(cfg =>
        cfg.triggerType === action.payload.triggerType ? action.payload : cfg
      );
      return assign({}, state, {
        offlineTriggerConfigs: updatedConfigs,
        offlineTriggerSaving: false,
        isTriggerSavedSuccessPopup: true,
        saveSuccessTriggerMessage: TriggersConstants.OFFLINE_TRIGGER_SAVED_MESSAGE
      });
    }

    case TriggersConstants.UPDATE_OFFLINE_TRIGGER_CONFIG_FAILURE:
      return assign({}, state, {
        offlineTriggerSaving: false,
        isTriggerSavedErrorPopup: true,
        saveErrorTriggerMessage: action.error || TriggersConstants.OFFLINE_TRIGGER_SAVE_ERROR_MESSAGE
      });

    case TriggersConstants.CLOSE_OFFLINE_SUCCESS_POPUP:
      return assign({}, state, {
        isTriggerSavedSuccessPopup: false,
        saveSuccessTriggerMessage: ""
      });

    case TriggersConstants.CLOSE_ERROR_TRIGGER_POPUP:
      return assign({}, state, {
        saveErrorTriggerMessage: "",
        isTriggerSavedErrorPopup: false
      });

    default:
      return state;
  }
}
